import {
  ChefHat,
  Table,
  IceCream,
  DollarSign,
  ShoppingCart,
  LayoutDashboard,
  BarChart,
  Tag,
  Package,
  FileText,
  Shuffle,
  User,
  Settings,
  LogOut,
  MessageCircle,
  TrendingUp,
  TrendingDown,
  Users,
  ShoppingBag,
  UserCog,
  Star,
  ClipboardList,
} from 'lucide-react';
import React from 'react';
import type { UserRole } from '../hooks/useRole';

export interface MenuItem {
  label: string;
  path: string;
  icon?: React.ReactElement;
  /** Legacy role filter (still used as fallback) */
  roles?: UserRole[];
  /** Permission module key – if set, item is hidden unless user can view this module */
  module?: string;
}

export const menuItems: MenuItem[] = [
  { label: 'Dashboard',    path: '/dashboard',          icon: <BarChart size={20} />,           module: 'dashboard' },
  { label: 'Reportes',     path: '/reports',             icon: <TrendingUp size={20} />,         module: 'reports' },
  { label: 'Historial',    path: '/orders/history',      icon: <ShoppingBag size={20} />,        module: 'order_history' },
  { label: 'KPIs',         path: '/kpi',                 icon: <LayoutDashboard size={20} />,    module: 'kpi' },
  { label: 'Clientes',     path: '/customers',            icon: <Star size={20} />,               module: 'customers' },
  { label: 'Usuarios',     path: '/users',               icon: <UserCog size={20} />,            module: 'users' },
  { label: 'Inventario',   path: '/inventory',           icon: <Package size={20} />,            module: 'inventory' },
  { label: 'Plano',        path: '/tables/floor',          icon: <LayoutDashboard size={20} />,    module: 'tables' },
  { label: 'Compras',      path: '/purchases',            icon: <ShoppingCart size={20} />,       module: 'purchases' },
  { label: 'Gastos',       path: '/purchases/expenses',   icon: <TrendingDown size={20} />,       module: 'purchases' },
  { label: 'Proveedores',  path: '/purchases/suppliers',  icon: <Users size={20} />,              module: 'purchases' },
  { label: 'WhatsApp Bot', path: '/whatsapp',            icon: <MessageCircle size={20} />,      module: 'whatsapp' },
  { label: 'Categorias',   path: '/categories',          icon: <Tag size={20} />,                module: 'categories' },
  { label: 'Productos',    path: '/products',            icon: <Package size={20} />,            module: 'products' },
  { label: 'Sabores',      path: '/flavors',             icon: <IceCream size={20} />,           module: 'flavors' },
  { label: 'Swagger',      path: '/swagger',             icon: <FileText size={20} />,           roles: ['admin'] },
  { label: 'Mesas',        path: '/tables',              icon: <Table size={20} />,              module: 'tables' },
  { label: 'POS',          path: '/pos',                 icon: <ShoppingCart size={20} />,       module: 'pos' },
  { label: 'Cocina',       path: '/kitchen',             icon: <ChefHat size={20} />,            module: 'kitchen' },
  { label: 'Caja',         path: '/cash',                icon: <DollarSign size={20} />,         module: 'cash' },
  { label: 'Movimientos',  path: '/cash/movements',      icon: <Shuffle size={20} />,            module: 'cash' },
  { label: 'Mercado',      path: '/shopping',            icon: <ClipboardList size={20} />,      module: 'shopping' },
  { label: 'Perfiles',     path: '/profiles',            icon: <UserCog size={20} />,            module: 'settings' },
  { label: 'Configuración',path: '/settings',            icon: <Settings size={20} />,           module: 'settings' },
  { label: 'Profile',      path: '/profile',             icon: <User size={20} /> },
  { label: 'Logout',       path: '/logout',              icon: <LogOut size={20} /> },
];
